/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Job service equipment.
 */
export enum JobServiceEquipment {
  INSULATION = 'insulation',
  BOILER = 'boiler',
  ELECTRIC_FURNACE = 'electric_furnace',
  GAS_FURNACE = 'gas_furnace',
  HEAT_PUMP = 'heat_pump',
  AIR_CONDITIONER = 'air_conditioner',
  EVAPORATIVE_COOLER = 'evaporative_cooler',
  GAS_WATER_HEATER = 'gas_water_heater',
  ELECTRIC_WATER_HEATER = 'electric_water_heater',
  HEAT_PUMP_WATER_HEATER = 'heat_pump_water_heater',
  AIR_SEALING = 'air_sealing',
  OTHER = 'other',
  BASEBOARD = 'baseboard',
  SPACE_HEATER = 'space_heater',
  PANEL = 'panel',
  WIRING = 'wiring',
  FURNACE = 'furnace',
  WATER_HEATER = 'water_heater',
  STOVE = 'stove',
  FIREPLACE = 'fireplace',
  VENTILATION = 'ventilation',
  LOAD_MANAGEMENT_DEVICE = 'load_management_device',
  CLOTHES_DRYER = 'clothes_dryer',
  INDUCTION_STOVE = 'induction_stove',
}
